<p>
  show-controls-bar works!
</p>
